<template>
  <SummaryCard
    :title="$t('views.portfolio.topPortfolioDailyPl.title')"
    :infoText="$t('views.portfolio.topPortfolioDailyPl.info')"
    :loading="loadingSummary"
    :value="dailyPlBaseCurrency"
    :valueCurrency="user.baseCurrency"
    valueShowPositive
    valuePositiveGreen
    :comparisonPercent="dailyPlBaseCurrencyPercent"
  />
</template>

<script>
import { get } from 'lodash'
import { mapState } from 'vuex'
import SummaryCard from '@/views/components/dashboardDetail/summary/SummaryCard'

export default {
  components: { SummaryCard },
  props: {
    summary: {
      type: Object,
      default: () => {},
    },
    loadingSummary: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
    }
  },
  computed: {
    ...mapState(['user']),
    dailyPlBaseCurrency() {
      return get(this.summary, 'dailyPlBaseCurrency', null)
    },
    dailyPlBaseCurrencyPercent() {
      return get(this.summary, 'dailyPlBaseCurrencyPercent', null)
    },
  },
}
</script>
